import styled from 'styled-components';

export const DivForm = styled.div`
    margin-top: 40px;
    display: table;
    margin-left:auto;
    margin-right:auto;
  }

  .input-AXS .inputError {
    border: 1px solid #D93D3D;
  }


  .MuiFormHelperText-root.Mui-error {
    color:#D93D3D;
  }
    .buttonback {
      cursor:pointer;
      width: 203px;
      height: 52px;
      background: #FFFFFF;
      border: 1px solid #6C5AF4;
      border-radius: 8px;
      color: #6C5AF4;
      font-weight: 700;
      font-size: 14px;
      @media (max-width: 700px){
        width: 130px;
        height: 49px;
      }
    }

    .buttonSend {
      cursor:pointer;
      width: 203px;
      height: 52px;
      background: #6C5AF4;
      border-radius: 8px;
      color: #FFFFFF;
      float:right;
      border:none;
      font-weight: 700;
      font-size: 14px;
      @media (max-width: 700px){
        width: 130px;
        height: 49px;
      }
    }
    .MuiInputBase-root{
      color: #757575;
      font-weight: 400;
      font-size: 14px;
    }
    .MuiOutlinedInput-root .MuiAutocomplete-input {
     max-height: 2px;
     padding: 0;
    }

    .MuiFormHelperText-root.Mui-error {
      color:#D93D3D;
      font-weight: 400;
      font-size: 15px;
  }

  .MuiFormLabel-root.Mui-error {
    color: #757575;
}

  .MuiFormHelperText-contained{
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
  }

  .MuiFormLabel-root
   {
    margin-left: 14px;
    font-family: Noto Sans, sans-serif;
    font-size: 14px;
  }
   
  @media (max-width: 700px){
    width: calc(100% - 335px) !important;
 }
`;


export const BigTitle = styled.div`
    font-weight: 500;
    font-family:'Kanit';
    font-size: 24px;
    line-height: 113%;
    text-align: center;
    color: #212121;
    padding-top: 47px;

    @media (max-width: 700px) {
      max-width: 90%;
      margin-left: auto;
      margin-right: auto;
    }
`;

export const InputLabelRadio = styled.label` 

.custoBoleto{
  color: #9E9E9E;
  font-weight: 400;
  font-size: 12px;
  position: absolute;
  margin-left: 5px;
  margin-top: 5px;
  font-family:'Open Sans, sans-serif';
}

.InputRadioPF {
  width: 24px;
  height: 24px;
  opacity: 1;
  vertical-align: middle;
  accent-color: #138561;
}

.InputRadioPF:hover {
  cursor: pointer;
}

.InputRadioPJ {
  width: 24px;
  height: 24px;
  opacity: 1;
  vertical-align: middle;

}

.InputRadioPJ:hover {
  cursor: pointer;
}

input[type="radio"] {
  appearance: none;
  margin: 0 10px;
  width: 19px;
  height: 19px;
  box-shadow: inset 0 0 0 0.4em white, 0 0 0 0.1em #6C5AF4;
  border-radius: 50%;
  transition: 0.2s;
  cursor: pointer;
  vertical-align: bottom;
}
  input[type="radio"]:hover, input[type="radio"]:checked {
    box-shadow: inset 0 0 0 0.6em white, 0 0 0 0.1em;
}
  input[type="radio"]:checked {
    background: #6C5AF4;
    box-shadow: inset 0 0 0 0.3em white, 0 0 0 0.1em #6C5AF4;
}
  input[type="radio"]:focus {
    outline: 0;
}
`;


export const Text = styled.div`
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #212121;
      margin: 27px 37px 0 115px;
     
      @media (max-width: 700px) {
        margin: 20px 25px -26px 76px;

      }
`;



export const DivResponsavel = styled.div`
      position: relative;
      font-family: 'Open Sans', sans-serif;
      font-family:'Kanit';
      @media (max-width: 700px){
        width: calc(100% - 32px);
     }

`;


export const DivPF = styled.div`
    position: relative;

    @media (max-width: 700px){
      width: calc(100% - 32px);
   }

`;

export const DivFatura = styled.div`
   position: relative;
   display: block;

   label input:checked ~ span {
    background-color: transparent;
    border: 2px solid #6C5AF4;
}

label span:after {
  top: 2px;
  right: 2px;
  bottom: 2px;
  left: 2px;
  border-radius: 50%;
  background: #6C5AF4;
}

   @media (max-width: 700px){
    display: inline-table;
  }

 .inputcc {
   min-width: 206px;
   max-width: 206px;

   @media (max-width: 700px){
     min-width: calc(100% - 16px);
   }
 }
`;


export const DivEmpresa = styled.div`
    display:grid;
    justify-content: space-between;
    align-items: start;
    flex-wrap: nowrap;
    grid-template-columns: auto auto;
    @media (max-width: 700px){
      grid-template-columns: auto;
   }
   .divHiddenBottom{
    visibility:hidden;
    @media (max-width: 700px){
      margin-bottom: -40px;
   }
   }
`;

export const DivInicio = styled.div`
    display:grid;
    justify-content: space-between;
    align-items: start;
    flex-wrap: nowrap;
    grid-template-columns: auto;

    @media (max-width: 700px){
      grid-template-columns: auto;
   }

  .input-AXS{
    width: 654px;
    height: 54px;
    background: #F5F5F5;
    border-radius: 8px;
    border:none;
    outline: none;
    color: #757575;
    font-weight: 400;
    font-size: 14px;
    position:relative;
    margin-bottom: 30px;
  } 

  .input-AXS input{
    width: 654px;
    height: 54px;
    background: #F5F5F5;
    border-radius: 8px;
    border:none;
    outline: none;
    color: #757575;

     &:focus {
      border: 1px solid #6C5AF4;
    }

    
  } 

  @media (max-width: 700px){
    .input-AXS{
      width: 332px;
      height: 54px;
      background: #F5F5F5;
      border-radius: 8px;
      border:none;
      outline: none;
      color: #757575;
      font-weight: 400;
      font-size: 14px;
      position:relative;
      margin-bottom: 25px;
    }
  
    .input-AXS input{
      width: 332px;
      height: 54px;
      background: #F5F5F5;
      border-radius: 8px;
      border:none;
      outline: none;
      color: #757575;
    }
 }
   `;

export const Title1 = styled.div`
   font-weight: bold;
   font-size: 1.5rem;
   text-align: center;
   color: #212121;
   margin-bottom: 1em;
   @media (max-width: 600px) {
     max-width: 100%;
   }
 `;


export const DivTableDrag = styled.div`

label {
  width:100% ;
}
    @media (max-width:600px){
        width: 344px;;
        display: block;
    }
 `;

export const DivButton = styled.div`
    @media (max-width: 700px){
      margin-left:auto;
      margin-right:auto;
    }
    .buttonBack {
        font-size: 0.875rem;
        font-weight: 700;
        text-transform: capitalize;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #6C5AF4;
        border-radius: 8px;
        color: #6C5AF4;
        @media (max-width: 700px){
          width: 130px;
          height: 49px;
        }
      }

      .buttonBack:hover {background: #FFFFFF}

      .buttonSend {
        font-size: 0.875rem;
        font-weight: 700;
        text-transform: capitalize;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #6C5AF4;
        border-radius: 8px;
        color: #FFFFFF;
        float:right;

        @media (max-width: 700px){
          width: 130px;
          height: 49px;
        }
      }

      .buttonSend:hover {background: #6C5AF4;}

 `;
